import { useEffect, useState } from 'react';
import clock from '../assets/icon_clock.svg';

/* Days/hours left to the campaign end. Shows whole days while more than 24h
   remain (e.g. "10 days left"), then switches to hours (e.g. "10h left").
   Shows a dash until the API has told us when the campaign ends. */
function remaining(endsAt) {
  if (!endsAt) return '--';
  const HOUR = 3600 * 1000;
  const DAY = 24 * HOUR;
  const diff = endsAt - Date.now();
  if (diff <= 0) return 'Ended';
  if (diff >= DAY) {
    const days = Math.ceil(diff / DAY);
    return `${days} ${days === 1 ? 'day' : 'days'} left`;
  }
  const hours = Math.max(1, Math.ceil(diff / HOUR));
  return `${hours}h left`;
}

/* Fixed top strip — scrolling message with a left fade, live countdown on the
   right. `text` and `endsAt` (epoch ms) come from the API banner / campaignEnd. */
export default function TopBanner({ text = '', endsAt = null }) {
  const [time, setTime] = useState(() => remaining(endsAt));

  useEffect(() => {
    setTime(remaining(endsAt));
    if (!endsAt) return undefined;
    const id = setInterval(() => setTime(remaining(endsAt)), 30000);
    return () => clearInterval(id);
  }, [endsAt]);

  return (
    <div className="bbd-banner">
      <div className="bbd-banner-marquee" aria-label={text}>
        <div className="bbd-banner-track" aria-hidden>
          <span>{text}</span>
          <span>{text}</span>
          <span>{text}</span>
          <span>{text}</span>
        </div>
      </div>
      <div className="bbd-banner-fade" />
      <div className="bbd-banner-timer">
        <img src={clock} alt="" />
        <span>{time}</span>
      </div>
    </div>
  );
}
